import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactJson from "react-json-view";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  SG_FETCH_POWERPOINT_REPORT,
  SG_DELETE_POWERPOINT_REPORT,
} from "constants/actions";
import { Icon, Button, Header, List } from "semantic-ui-react";
import { format } from "date-fns";

const Details = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [reportDetails, setReportDetails] = useState(null);

  const { presentationReportDetails, pending } = useSelector(
    (state) => ({
      presentationReportDetails: state.presentation_report.reportDetails,
      pending: state.presentation_report.pending,
    }),
    shallowEqual
  );


  useEffect(() => {
    if (id) {
      dispatch({
        type: SG_FETCH_POWERPOINT_REPORT,
        payload: { id },
      });
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (presentationReportDetails) {
      setReportDetails(presentationReportDetails);
    }
  }, [presentationReportDetails]);

  const handleDelete = () => {
    // if (id) {
    //   dispatch({
    //     type: SG_DELETE_POWERPOINT_REPORT,
    //     payload: { id },
    //   });
    //   navigate("/app/presentation-reports");
    // }
  };

  const handleBack = () => {
    navigate("/app/presentation-report");
  };

  // console.log(reportDetails);

  return (
    <>
      <Header as="h2">
        <Icon
          style={{ cursor: "pointer" }}
          onClick={handleBack}
          name="arrow left"
        />
        Presentation Report Details
      </Header>
      {pending && <p>Loading...</p>}
      {reportDetails && (
        <>
          <SingleRowContent>
            <span>
              Created By Employee: {reportDetails?.employee} -{" "}
              {reportDetails?.employee_email}
            </span>
          </SingleRowContent>
          <SectionDiv>
            <Container>
              <List horizontal>
                <List.Item>
                  <List.Content>
                    <ListContainer>
                      <List.Header>Status</List.Header>
                      {reportDetails?.status}
                    </ListContainer>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <ListContainer>
                      <List.Header>Tracking Code</List.Header>
                      {reportDetails?.tracking_code}
                    </ListContainer>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <ListContainer>
                      <List.Header>Created</List.Header>
                      {reportDetails?.created_at &&
                        format(
                          new Date(reportDetails?.created_at),
                          "dd-MMM-yyyy hh:mm a"
                        )}
                    </ListContainer>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <ListContainer>
                      <List.Header>Last Updated</List.Header>
                      {reportDetails?.updated_at &&
                        format(
                          new Date(reportDetails?.updated_at),
                          "dd-MMM-yyyy hh:mm a"
                        )}
                    </ListContainer>
                  </List.Content>
                </List.Item>
              </List>
            </Container>
          </SectionDiv>
          <SectionDiv>
            <ReactJson src={reportDetails?.details} />
          </SectionDiv>
          {/* <SectionDiv lastSection={true}>
            <Button floated="right" color="red" onClick={handleDelete}>
              Delete Report
            </Button>
          </SectionDiv> */}
        </>
      )}
    </>
  );
};

export default Details;

const SectionDiv = styled.div`
  margin: 10px 0px;
  margin-bottom: ${(props) => (props.lastSection === true ? "100px" : "20px")};
  border: ${(props) =>
    props.bordered === true ? "1px solid #dcdcdc;" : "none"};
  padding: ${(props) => (props.bordered === true ? "20px;" : "10px 0px;")};
`;

const Container = styled.div`
  display: flex;
`;

const ListContainer = styled.div`
  margin: 0px 25px;
`;

const SingleRowContent = styled.div`
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;